import { ISession } from 'interfaces/session/ISession';
import mappingHelpers from './mappingHelpers';

type ColumnCount = [string, string, string, string, string];

const exportSessionsToCSV = (sessions: ISession[], fileName: string) => {
  const headers = (['Time (Local)', 'Home Team', 'Level', 'League', 'Game Ref.'] as ColumnCount).join(',').concat('\n');

  const csvRows = sessions
    .filter((s) => !s.isBattingPractice)
    .map((session) => {
      const values: ColumnCount = [
        mappingHelpers.timeDisplay(session.localStartTime) || '',
        session.homeTeam?.name || '',
        session.level?.name || '',
        session.league?.name || '',
        session.gameReference || '',
      ];

      values.forEach((value) => {
        if (value.includes(',') || value.includes('"') || value.includes('\n')) {
          return `"${value.replace(/"/g, '""')}"`;
        }
        return value;
      });

      return values.join(',');
    })
    .join('\n');

  const blob = new Blob([headers, csvRows], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  link.setAttribute('href', url);
  link.setAttribute('download', `${fileName}.csv`);
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export default { exportSessionsToCSV };
